import React, { Component, ReactNode } from "react";

import { HStack } from "@formant/ui/component/common/HStack";
import { VStack } from "@formant/ui/component/common/VStack";

import * as styles from "./IntegrationRow.scss";

export interface IIntegrationRowProps {
    logoSrc: string;
    name: string;
    description: string;
    actions: ReactNode;
    children?: React.ReactNode;
}

export class IntegrationRow extends Component<IIntegrationRowProps> {
    public render() {
        const { logoSrc, name, description, actions, children } = this.props;
        return (
            <VStack innerSpacing="sm" className={styles["integration-row"]}>
                <HStack vAlign="center" innerSpacing="md">
                    <img className={styles.logo} src={logoSrc} />
                    <div className={styles.name} data-testid={`name-${name}`}>
                        {name}
                    </div>
                    <div
                        className={styles.description}
                        data-testid={`description-${name}`}
                    >
                        {description}
                    </div>
                    <HStack innerSpacing="sm">{actions}</HStack>
                </HStack>
                {children}
            </VStack>
        );
    }
}
